import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import LoyaltyOfferPerformanceApiDefinitions from './loyalty-offer-performance-api-definitions/loyalty-offer-performance-api-definitions.component';

type LoyaltyOfferPerformanceAPIDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

const LoyaltyOfferPerformanceAPIDetailsDrawer = ({
  isOpen,
  close,
}: LoyaltyOfferPerformanceAPIDetailsDrawerProps) => {
  const { t } = useTranslation();
  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t(
        'page.loyaltyPerformanceReport.tabs.loyaltyOfferPerformance.label',
      )}
    >
      <UtilityDrawerBody>
        <LoyaltyOfferPerformanceApiDefinitions />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default LoyaltyOfferPerformanceAPIDetailsDrawer;
